"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _excluded = ["children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultProps = {
  className: 'react-tabs__tab-list'
};
var propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object])
} : {};

var TabList = function TabList(props) {
  var children = props.children,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement("ul", _extends({}, attributes, {
    className: (0, _clsx["default"])(className),
    role: "tablist"
  }), children);
};

TabList.tabsRole = 'TabList';
TabList.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
TabList.defaultProps = defaultProps;
var _default = TabList;
exports["default"] = _default;